// Dumb file name, but this is where we put common, non-page-specific logic

import initReactApp from 'dpl/util/initReactApp';
import ToastNotificationsListContainer from 'dpl/containers/ToastNotificationsListContainer';
import UserAuthModalContainer from 'dpl/containers/UserAuthModalContainer';

initReactApp({
  ToastNotificationsListContainer,
  UserAuthModalContainer
});
